module.exports = __webpack_public_path__ + "img/demo-social.05a5f8b9.jpeg";